// src/lib/fw.js
import {
    collection,
    doc,
    serverTimestamp,
    arrayUnion,
    arrayRemove,
    increment,
  } from "firebase/firestore";
  import { db } from "./firebase";
  
  /**
   * Normalize inputs so you can call:
   *   col("leagues", leagueID, "gameweeks")
   *   col(["leagues", leagueID, "gameweeks"])
   *   col("leagues/LEAGUE_ID/gameweeks")   // single slash-delimited string
   */
  function normalizeSegments(segments) {
    // unwrap single array argument
    if (segments.length === 1 && Array.isArray(segments[0])) {
      segments = segments[0];
    }
  
    // allow single slash-delimited string (Firestore accepts this)
    if (segments.length === 1 && typeof segments[0] === "string") {
      return [segments[0]];
    }
  
    // ensure all are strings
    for (const s of segments) {
      if (typeof s !== "string") {
        throw new Error(
          `fw: path segment is not a string.\nGot: ${JSON.stringify(
            s
          )}\nSegments: ${JSON.stringify(segments)}`
        );
      }
    }
    return segments;
  }
  
  // Collection/document creators that accept flexible inputs
  export const col = (...segments) => {
    const segs = normalizeSegments(segments);
    return collection(db, ...segs);
  };
  
  export const ref = (...segments) => {
    const segs = normalizeSegments(segments);
    return doc(db, ...segs);
  };
  
  // Convenience single-string variants
  export const colPath = (pathString) => {
    if (typeof pathString !== "string") {
      throw new Error(`fw.colPath: expected string, got ${typeof pathString}`);
    }
    return collection(db, pathString);
  };
  
  export const refPath = (pathString) => {
    if (typeof pathString !== "string") {
      throw new Error(`fw.refPath: expected string, got ${typeof pathString}`);
    }
    return doc(db, pathString);
  };
  
// Re-export useful FieldValue helpers
export { serverTimestamp, arrayUnion, arrayRemove, increment };
export { db };